module.exports = __webpack_public_path__ + "static/img/SFG124_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/SFG124_1.png
// module id = tnqb
// module chunks = 0